// @needsAudit
export var KeepAwakeEventState;
(function (KeepAwakeEventState) {
    KeepAwakeEventState["RELEASE"] = "release";
})(KeepAwakeEventState || (KeepAwakeEventState = {}));
//# sourceMappingURL=KeepAwake.types.js.map